/*
    Be aware, that this script calls app from /apps/plans
    There is an old plans app in js-frontend but it's not used anymore
 */

import {isProduction} from "../app/read_rp_environment_variables";

declare global {
    interface Window {
        __pg__scripts: unknown;
    }
}

export const PLANS_SCRIPT_ID = "__pg__plans_script";

export interface IRpPlansInitProps {
    renderApplicationButton: (propertyId: number) => void;
    renderFavouriteButton: (propertyId: number) => void;
}

export interface IPlansTrackingData {
    view_type: string;
    site: string;
    site_id: number;
}

let isPlansScriptInitialized = false;
let plansApi: {openModal: (config: Object) => void} | null = null;
export const initializePlansScript = async (
    offerId: number,
    source: number,
    site: string,
    trackingData: IPlansTrackingData,
    props: IRpPlansInitProps
): Promise<void> => {
    if (isPlansScriptInitialized) {
        plansApi && plansApi.openModal({source});
        return;
    }
    isPlansScriptInitialized = true;
    window.__pg__scripts = {
        plansScriptId: PLANS_SCRIPT_ID,
        offerId,
        source,
        trackingData,
        onLoad: (api: {openModal: () => void}) => {
            plansApi = api;
            plansApi.openModal({source});
        },
        renderApplicationButton: props.renderApplicationButton,
        renderFavouriteButton: props.renderFavouriteButton
    };
    // fetch scripts
    const manifest = isProduction
        ? await getFetch(`${site}/static-plans/manifest.json?${new Date().getTime()}`).catch((e) => {
              console.error("manifest error: ", e);
              return null;
          })
        : null;
    const plans = (manifest && manifest["plans.js"]) || "plans.js";
    const plansVendor = (manifest && manifest["vendor.js"]) || null;
    const fetchArray = [
        plansVendor != null ? fetchScript(`${site}/static-plans/${plansVendor}`) : Promise.resolve(),
        fetchScript(`${site}/static-plans/${plans}`)
    ];
    return Promise.all(fetchArray).then(() => undefined); // we need to return nothing
};

const fetchScript = (url: string): Promise<void> =>
    new Promise((resolve) => {
        const firstScriptElem = document.getElementsByTagName("script")[0];
        const plansVendorScript = document.createElement("script");
        plansVendorScript.async = true;
        plansVendorScript.onload = () => resolve();
        plansVendorScript.src = url;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        firstScriptElem!.parentNode!.insertBefore(plansVendorScript, firstScriptElem);
    });

/**
 * Fetch
 */
export const getFetch = (url: string) => {
    return fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        credentials: "same-origin"
    }).then(async (res) => {
        const body = await res.json();
        if (400 <= res.status && res.status < 500) {
            throw new Error(`400: ${JSON.stringify(body)}`);
        }
        return body;
    });
};
/*
    Be aware, that this script calls app from /apps/plans
    There is an old plans app in js-frontend but it's not used anymore
 */

import {isProduction} from "../app/read_rp_environment_variables";

declare global {
    interface Window {
        __pg__scripts: unknown;
    }
}

export const PLANS_SCRIPT_ID = "__pg__plans_script";

export interface IRpPlansInitProps {
    renderApplicationButton: (propertyId: number) => void;
    renderFavouriteButton: (propertyId: number) => void;
}

export interface IPlansTrackingData {
    view_type: string;
    site: string;
    site_id: number;
}

let isPlansScriptInitialized = false;
let plansApi: {openModal: (config: Object) => void} | null = null;
export const initializePlansScript = async (
    offerId: number,
    source: number,
    site: string,
    trackingData: IPlansTrackingData,
    props: IRpPlansInitProps
): Promise<void> => {
    if (isPlansScriptInitialized) {
        plansApi && plansApi.openModal({source});
        return;
    }
    isPlansScriptInitialized = true;
    window.__pg__scripts = {
        plansScriptId: PLANS_SCRIPT_ID,
        offerId,
        source,
        trackingData,
        onLoad: (api: {openModal: () => void}) => {
            plansApi = api;
            plansApi.openModal({source});
        },
        renderApplicationButton: props.renderApplicationButton,
        renderFavouriteButton: props.renderFavouriteButton
    };
    // fetch scripts
    const manifest = isProduction
        ? await getFetch(`${site}/static-plans/manifest.json?${new Date().getTime()}`).catch((e) => {
              console.error("manifest error: ", e);
              return null;
          })
        : null;
    const plans = (manifest && manifest["plans.js"]) || "plans.js";
    const plansVendor = (manifest && manifest["vendor.js"]) || null;
    const fetchArray = [
        plansVendor != null ? fetchScript(`${site}/static-plans/${plansVendor}`) : Promise.resolve(),
        fetchScript(`${site}/static-plans/${plans}`)
    ];
    return Promise.all(fetchArray).then(() => undefined); // we need to return nothing
};

const fetchScript = (url: string): Promise<void> =>
    new Promise((resolve) => {
        const firstScriptElem = document.getElementsByTagName("script")[0];
        const plansVendorScript = document.createElement("script");
        plansVendorScript.async = true;
        plansVendorScript.onload = () => resolve();
        plansVendorScript.src = url;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        firstScriptElem!.parentNode!.insertBefore(plansVendorScript, firstScriptElem);
    });

/**
 * Fetch
 */
export const getFetch = (url: string) => {
    return fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        credentials: "same-origin"
    }).then(async (res) => {
        const body = await res.json();
        if (400 <= res.status && res.status < 500) {
            throw new Error(`400: ${JSON.stringify(body)}`);
        }
        return body;
    });
};
